// extracted by mini-css-extract-plugin
module.exports = {"hide":"VSReader__hide--20QKkVSwZC"};